"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CanvasNode;
var L = require("leaflet");
var createjs = require("@caddigital/easeljs/lib/easeljs");
var Matrix_1 = require("./Matrix");
/**
 * TODO: REFACTOR THIS TO OWN FILE
 * convert latlng to point
 */
var latlngToPoint = function (map, coords, pointCoordinate, zoom) {
    var p = map.project(pointCoordinate, zoom);
    var x = Math.round(p.x - coords.x);
    var y = Math.round(p.y - coords.y);
    // coords to tile space
    return new L.Point(x, y);
};
function CanvasNode(type, map, latlng, stroke, fill) {
    var _this = this;
    var origin = map.getPixelOrigin();
    var point = latlngToPoint(map, origin, latlng, map.getZoom());
    createjs.Shape.call(this);
    this.stroke = stroke;
    this.fill = fill;
    this.type = type;
    this.latlng = latlng;
    this.width = 0;
    this.height = 0;
    this._vx = 0;
    this._vy = 0;
    this.MAX_SPEED = 50;
    this._map = map;
    this._canvas = map._canvas;
    this._ctx = this._canvas.getContext('2d');
    this._width = this.width;
    this._height = this.height;
    this._update = false;
    this._drawing = false;
    this._selected = false;
    this._scaleOrigin = null;
    this._rotationOrigin = null;
    this._rotationStart = null;
    this._angle = 0;
    this._initialDist = 0;
    this._initialDistX = 0;
    this._initialDistY = 0;
    this._offset = new L.Point(0, 0);
    this._scale = map.options.crs && map.options.crs.scale(map.getZoom());
    this.x = this.regX = point.x;
    this.y = this.regY = point.y;
    this._x = 0;
    this._y = 0;
    this._matrix = new Matrix_1.default(1, 0, 0, 1, this.x, this.y);
    this._projectedMatrix = new Matrix_1.default(1, 0, 0, 1, 0, 0);
    this._initialMatrix = new Matrix_1.default(1, 0, 0, 1, 0, 0);
    this._copyContainer = map._backCanvas;
    this._copyCtx = map._backCanvas.getContext('2d');
    /**
     * Apply scale to matrix
     *
     * @param {L.Point | Number} scale
     * @param {L.LatLng} origin
     * @return
     */
    this.__scale = function (toScale, origin) {
        if (typeof toScale === 'number') {
            toScale = new L.Point(toScale, toScale);
        }
        _this._matrix = _this._initialMatrix.clone().scale(toScale, origin).flip();
        _this.transform(_this._matrix);
        _this.update();
    };
    /**
     * Apply angle to matrix
     *
     * @param {L.Point | Number} angle
     * @param {L.LatLng} origin
     * @return
     */
    this.__rotate = function (angle, origin) {
        _this._matrix = _this._initialMatrix.clone().rotate(angle, origin).flip();
        _this.transform(_this._matrix);
        _this.update();
    };
    /**
     * Placeholder for update bounds callback
     */
    this.updateBoundingBox = function () {
        return;
    };
    /**
     * Placeholder for latlng update callback
     */
    this.updateLatLng = function () {
        return;
    };
    /**
     * Apply px coordinate to matrix
     *
     * @param {L.Point} delta
     */
    this.onMove = function (evt, delta) {
        var zoom = _this._map.getZoom();
        var crs = _this._map.options.crs;
        var scale = crs.scale(zoom);
        var _scale = scale / _this._scale;
        _this._matrix = _this._matrix
            .clone()
            .translate(new L.Point(delta.x / _scale, delta.y / _scale));
        _this._initialMatrix = _this._matrix;
        _this.transform(_this._matrix);
        _this._draw();
    };
    /**
     * Called when move end event happens
     * @param {Event} evt
     */
    this.onMoveEnd = function (evt) {
        _this.update();
    };
    this.getCenter = function () {
        throw new Error('Implement get center');
    };
    /**
     * fires when repositioning of layer happens
     * @param {Event} evt
     */
    this.onReposition = function (evt) {
        var origin = _this._map.getPixelOrigin();
        var crs = _this._map.options.crs;
        var scale = crs.scale(_this._map.getZoom());
        var _scale = scale / _this._scale;
        var point = latlngToPoint(_this._map, origin, _this.latlng, _this._map.getZoom());
        if (_this._offset) {
            point = point.subtract(_this._offset.multiplyBy(_scale));
        }
        if (_this._map.dragging._draggable._newPos) {
            point = point.add(_this._map.dragging._draggable._newPos);
        }
        _this._initialMatrix = new Matrix_1.default(1, 0, 0, 1, 0, 0);
        _this._matrix = _this._initialMatrix
            .clone()
            .translate(point)
            .scale(_scale, new L.Point(0, 0));
        _this.transform(_this._matrix);
        _this.update();
    };
    /**
     * fires when scaling of node starts and stores initial values of the transform
     * @param {Event} evt
     * @param {L.Map} map
     */
    this.onScaleStart = function (evt) {
        _this._initialMatrix = _this._matrix.clone();
    };
    /**
     * fires when transform is ongoing and stores current values of the transform
     * @param {Event} evt
     * @param {L.Map} map
     */
    this.onScale = function (evt) {
        var origin = _this._map.getPixelOrigin();
        var crs = _this._map.options.crs;
        var scale = crs.scale(_this._map.getZoom());
        var _scale = scale / _this._scale;
        var point = latlngToPoint(_this._map, origin, _this.latlng, _this._map.getZoom());
        if (_this._offset) {
            var offset = _this._offset.multiplyBy(_scale);
            point = point.subtract(offset);
        }
        if (_this._map.dragging._draggable._newPos) {
            point = point.add(_this._map.dragging._draggable._newPos);
        }
        _this._initialMatrix = new Matrix_1.default(1, 0, 0, 1, 0, 0);
        _this._matrix = _this._initialMatrix
            .clone()
            .translate(point)
            .scale(_scale, new L.Point(0, 0));
        _this.transform(_this._matrix);
        _this._draw();
    };
    /**
     * fires when transform ends and resets values to new positions
     * @param {Event} evt
     * @param {L.Map} map
     */
    this.onScaleEnd = function (evt) {
        _this.update();
    };
    /**
     * calculate projection matrix with angle and scale applied to it
     *
     * @param {Number} angle
     * @param {L.Point} scale
     * @param {L.LatLng} rotationOrigin
     * @param {L.LatLng} scaleOrigin
     * @return {Matrix}
     */
    this._getProjectedMatrix = function (angle, scale, point) {
        var matrix = new Matrix_1.default(1, 0, 0, 1, 0, 0);
        if (!(scale.x === 1 && scale.y === 1)) {
            matrix = matrix
                .add(1, 0, 0, 1, point.x, point.y)
                .add(scale.x, 0, 0, scale.y, 0, 0)
                .add(1, 0, 0, 1, -point.x, -point.y);
        }
        if (angle) {
            matrix = matrix.rotate(angle, point).flip();
        }
        return matrix;
    };
    /**
     * make ui related changes, called when state changes
     */
    this.update = function () {
        throw new Error('Implement update');
    };
    /**
     * @param {Matrix} matrix
     */
    this.transform = function (_) {
        throw new Error('Implement _applyTransform');
    };
    /**
     * Transfrom point according to new map projection
     *
     * @param {L.LatLng} latlng
     * @param {L.Matrix} matrix
     * @param {L.Map} map
     * @param {Number} zoom
     * @return {L.LatLng}
     */
    this._transformPoint = function (latlng, matrix, map, zoom) {
        return map.unproject(matrix.transform(map.project(latlng, zoom)), zoom);
    };
    /**
     * Update selected state and redraw the element
     *
     * @param {Boolean} selected
     */
    this.setSelected = function (selected) {
        _this._selected = selected;
        _this._draw();
    };
    this._onClick = function () {
        if (_this.onClick) {
            _this.onClick();
        }
    };
}
CanvasNode.prototype = new createjs.Shape();
